import { render } from "./RateBox.vue?vue&type=template&id=29fc856c&scoped=true"
import script from "./RateBox.vue?vue&type=script&lang=js"
export * from "./RateBox.vue?vue&type=script&lang=js"

import "./RateBox.vue?vue&type=style&index=0&id=29fc856c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fc856c"]])

export default __exports__